<template>
  <div class="assignments-item">
    <div class="assignments-item-header">
      <widgetProfile :title="item.title" :subtitle="item.address"
        :file_name="$hasKey(item, 'user.customer_profile.logo') ? item.user.customer_profile.logo : $hasKey(item, 'user.company_profile.logo') ? item.user.company_profile.logo : ''"
        :path="$fullUrl('images/profiles/')" :size="50" :text_size="18">
      </widgetProfile>

      <div class="assignments-item-options">
        <div class="posted-date">
          {{
            moment(item.created_at).format(
              "ddd, MMMM Do YYYY"
            ) | validate
          }}

        </div>
        <dropdownMenu v-if="type == 'our'" class="options">
          <ul>
            <li>
              <a href @click.prevent="assingConsultant(item)">Assign</a>
            </li>
            <li v-if="item.status == 0">
              <a href @click.prevent="publish(item.id)">Publish</a>
            </li>
            <li v-else>
              <a href @click.prevent="unpublish(item.id)">
                Unpublish</a>
            </li>
            <li>
              <a href="#" @click.prevent="editAssignment(item)">Edit</a>
            </li>
            <li>
              <app-dialog title="Delete Assignment" ask="Are you sure you want to permanently delete this assignment?"
                yesText="Delete" noText="Cancel" yesBtnClass="btn-danger" @onComfirm="deleteAssingment(item)">
                <a href="#">Delete</a>
              </app-dialog>
            </li>
          </ul>
        </dropdownMenu>
      </div>


    </div>

    <div class="assignments-item-body">
      <div class="assingment-role">{{ item.role | validate }}</div>
      <label v-if="
        false && $hasKey(item, 'user.company_profile.name')
      ">{{ item.user.company_profile.name | validate }}</label>
      <label v-show="false" v-else>{{
        item.customer | validate
      }}</label>
      <div class="assignments-info">
        <p class="assignment-desc" v-readMore:200="item.description"></p>

        <div class="assign-skills-widget" v-if="item.skills.length > 0">
          <div class="item" v-for="(skill, i) in item.skills" :key="i">
            <span class="name">{{ skill | validate }}</span>
          </div>
        </div>

        <p>
          {{ item.due_date_from | formatDate | validate }}
          <template v-if="item.is_urgent">/ As soon as possible</template>
        </p>
        <p class="rate">
          {{ item.rate | validate }}
          <template v-if="item.is_negotiable">/ Negotiable</template>
        </p>
      </div>

    </div>
    <div class="item-option">

      <widgetButton :loading="false" v-if="type == 'normal' || type == 'our'" @click="assingConsultant(item)"
        class="btn-secondary">
        Assign to consultant
      </widgetButton>

      <widgetButton :loading="false" v-if="type == 'feed'" @click="Contact(item)" class="btn-secondary">
        Contact
      </widgetButton>


      <div v-if="type == 'assigned'" class="member-section">
        <span class="assinged-label">Assigned</span>
        <div class="collaboraters-widget">
          <div class="item" v-for="(member, i) in item.members" :key="i">
            <img v-if="member.profile_picture" class="profile-img" :class="{ override: i > 0 }" :src="
              $fullUrl(
                'images/profiles/' + member.profile_picture
              )
            " />
            <img class="profile-img" v-else src="@/assets/icons/logo_avatar.svg" />
            <span class="name" v-if="item.members.length == 1">{{ member.first_name | validate }}
              {{ member.last_name | validate }}</span>
          </div>
        </div>
      </div>
      <div class="assignment-time">
        <div class="time">
          <img src="@/assets/admin-icon/blue-clock.svg" />
          <span>{{ item.work_load | validate }}</span>
          <span class="sepalator" v-if="item.work_load">|</span>
          <span>{{ item.duration | validate }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "assignmentItem",
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    type: {
      type: String,
      default: "normal",
    },
  },
  data() {
    return {
    };
  },
  watch: {},
  mounted() {
    let vm = this;

  },
  methods: {
    assingConsultant(item) {
      this.$emit('onAssign', item);
    },
    publish(id) {
      this.$emit('onPublish', id);
    },
    unpublish(id) {
      this.$emit('onUnpublish', id);
    },
    editAssignment(item) {
      this.$emit('onEdit', item);
    },
    deleteAssingment(item) {
      this.$emit('onDelete', item);
    },
    Contact(item) {
      this.$emit('onContact', item);
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit SCSS to this component only -->
<style scoped lang="scss">
.assignments-item {
  background: #FFFFFF;
  border: 1px solid #EAEAEA;
  border-radius: 5px;
  margin-bottom: 10px;
  position: relative;

  @media (min-width: 300px) and (max-width: 630px) {
    padding: 0px 0px;
  }

  .assignments-item-header {
    display: flex;
    padding: 10px 14px;
    justify-content: space-between;
    align-items: center;

    .assignments-item-options {
      display: flex;
      align-items: center;

      .posted-date {
        font-family: 'Nunito';
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        text-align: right;
        color: #A1A1AA;

      }

      .options {
        margin-left: 10px;
      }
    }
  }

  .assignments-item-body {
    padding-left: 20px;
    padding-right: 20px;

    .assingment-role {
      font-family: 'Nunito';
      font-style: normal;
      font-weight: 700;
      font-size: 16px;
      color: #18181B;
      margin: 10px 0px;
    }

    .assignment-desc {
      color: #707070;
      margin-bottom: 11px;
    }

    .assign-skills-widget {
      padding: 0px 0px;
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 5px;

      .item {
        background: #E8E8E8;
        border-radius: 24px;
        display: flex;
        align-items: center;
        padding: 4px 10px;
        margin-right: 8px;
        margin-bottom: 8px;

        .name {
          color: #707070;
        }
      }
    }


    .rate {
      margin-top: 10px;
    }


  }

  .item-option {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 5px 20px;
    border-top: 1px solid rgb(223, 223, 223);

    .member-section {
      display: flex;
      align-items: center;

      .assinged-label {
        height: 30px;
        color: #fff;
        background: #1ba5a4;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 80px;
        margin-right: 8px;
      }

      .collaboraters-widget {
        display: flex;
        align-items: center;

        .item {
          display: flex;
          align-items: center;

          .profile-img {
            width: 18px;
            height: 18px;
            border-radius: 50%;
            border: 1px solid #ddd;
            background: #fff;

            &.override {
              position: relative;
              left: -5px;
            }
          }
        }
      }
    }

    .btn-assing {
      background: #0884af;
      border-radius: 4px;
      height: 35px;
      color: #fff;
      padding: 0px 15px;
    }

    .assignment-time {
      color: #1ba5a4;

      .time {
        display: flex;
        align-items: center;

        img {
          width: 15px;
          margin-right: 5px;
          margin-top: -4px;
        }
      }

      .sepalator {
        margin: 0 5px;
      }

      span {
        color: #1ba5a4;
      }
    }
  }
}
</style>